import type { FunctionComponent, ReactNode } from "react";

import { Spacer } from "~/components/common/spacer";

import CloseIcon from "./close-icon.svg";
import { CloseButton, Container, Content, FullWidthBackground } from "./styles";

export type Props = {
  children?: ReactNode;
  className?: string;
  onClose?: () => void;
};

export const NotificationItem: FunctionComponent<Props> = ({ children, className, onClose }) => (
  <Container className={className}>
    <FullWidthBackground />
    <Content>
      {children}
      <Spacer />
      <CloseButton disableRipple onClick={onClose}>
        <CloseIcon />
      </CloseButton>
    </Content>
  </Container>
);

NotificationItem.displayName = "NotificationItem";
